module.exports = __webpack_public_path__ + "media/images/freedial-842912c416ac12d1d523b57292f68544.svg";